var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"text-center"},[_vm._v("Launching Soon")])
}
var staticRenderFns = []

export { render, staticRenderFns }